import type { AttributesEntity } from '@eliadmin/core/src/api/products/types/product-types';
import { useVariantsStore } from '@eliadmin/core/src/stores/variant-store';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import { ToggleGroup, ToggleGroupItem } from '@eliadmin/core/src/components/ui/toggle-group';

export default function ProductVariantRadio({ attribute }: { attribute: AttributesEntity }) {
  const selectedValues = useVariantsStore(state => state.selectedValues);
  const updateSelectedValue = useVariantsStore(state => state.updateSelectedValue);

  return (
    <ToggleGroup
      value={String(
        selectedValues.find(selectedValue => selectedValue.attribute.id === attribute.id)?.value.id,
      )}
      type="single"
      className={cn('flex-wrap justify-start', 'ea-product-detail-variant__toggle-group')}
    >
      {attribute.values?.map((value, i) => {
        return (
          <div
            key={`radio-attribute-${i}`}
            className={cn(
              'flex flex-row items-center space-x-2',
              'ea-product-detail-variant__toggle-group-item-wrapper h-auto',
              '',
            )}
          >
            <ToggleGroupItem
              key={`radio-attribute-${i}`}
              value={String(value.id)}
              onClick={() => {
                updateSelectedValue({ attribute, value });
              }}
              className={cn(
                'rounded-md border-[1px] border-border text-start',
                'ea-product-detail-variant__toggle-group-item',
              )}
            >
              {value.name}
            </ToggleGroupItem>
          </div>
        );
      })}
    </ToggleGroup>
  );
}
